import { Theme } from "@mui/material";
import { base, gray } from "configs/colors";
import { shadows } from "configs/shadows";

export const generateFormFieldStyles = ({
  theme,
  color,
}: {
  theme: Theme;
  color?: "primary" | "secondary" | "error" | "info" | "success" | "warning";
}) => {
  const palette = theme.palette[color ?? "primary"] as unknown as Record<
    number | string,
    string
  >;
  const errorPalette = theme.palette.error as unknown as Record<
    number | string,
    string
  >;
  return {
    normal: {
      backgroundColor: base.White,
      borderColor: gray[300],
      boxShadow: shadows.xs,
      hover: {
        borderColor: palette[300],
      },
      focus: {
        borderColor: palette[300],
        boxShadow: `0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px ${palette[100]}`,
      },
    },
    disabled: {
      backgroundColor: gray[100],
      borderColor: gray[300],
      color: gray[500],
    },
    error: {
      hover: {
        borderColor: errorPalette[300],
      },
      focus: {
        borderColor: errorPalette[300],
        boxShadow: `0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px ${errorPalette[100]}`,
      },
    },
  };
};
